import { Component, OnInit } from '@angular/core';
import { ItemService } from '../s/item.service';
import { item } from '../m/item';

@Component({
  selector: 'app-add-item',
  templateUrl: './add-item.component.html',
  styleUrls: ['./add-item.component.css']
})
export class AddItemComponent implements OnInit {

  items: item[];

  item: item = {
    ars: '',
  }


  constructor(private ItItemService:ItemService) { }

  ngOnInit(): void {
    this.ItItemService.getItemars().subscribe(items => {
      this.items = items;
    });
  }

  onSub(){
    if(this.item.ars != ''){
      this.ItItemService.additem(this.item);
      this.item.ars = "";
    }
  }
  updateitem(){
    this.ItItemService.updateitem(this.item);
    this.item.ars = "";
  }

}
